module.exports = __webpack_public_path__ + "img/heroSmall.d62abb81.jpg";